import 'workspaces/launcher/styles';
import 'workspaces/launcher/properties';
import 'workspaces/launcher/images';

import 'workspaces/common/styles';
import 'workspaces/common/properties';

import 'sharedreact/styles';
import 'sharedreact/properties';
import 'sharedreact/fonts';

import React from 'react';
import { createRoot } from 'react-dom/client';
import AppContainer from 'workspaces/launcher/AppContainer';
import { HashRouter } from 'react-router-dom';

const app = document.getElementById('app');

if (app != null) {
  const root = createRoot(app);
  root.render(
    <HashRouter>
      <AppContainer />
    </HashRouter>
  );
}
